import {Img} from './style.js';
import WhatsApp from '../../assets/whatsapp.png';
function WhatsappButton() {
  return (
  <>
  <a href='https://w.app/contavares' target='_blank' rel="noreferrer noopener">
   <Img src={WhatsApp} alt="WhatsApp"/>
  </a>
  </>
  );
}
export default WhatsappButton;